module.exports = __webpack_public_path__ + "img/firebase.44f9194d.png";